import React from 'react';
import { View, StyleSheet } from 'react-native';
import { CommonProperties, CommonStyles } from '../../../styles';
import EventList from './EventList';
import Modal from '../../Modal';
import BaseText from '../../BaseText';
import Button, { BUTTON_TYPES } from '../../Button';

const EventModal = ({ data, visible, onPress }) => {
  return (
    <Modal visible={visible} transparent={true}>
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          <BaseText style={styles.title}>
            Select your option bellow to book travel for this trip:
          </BaseText>
          <EventList data={data} />
          <Button
            label="Book Same Trip"
            style={styles.firstButton}
            labelStyle={CommonStyles.h4}
            onPress={() => onPress(0)}
          />
          <Button
            label="Create Custom Options"
            type={BUTTON_TYPES.TEXT}
            labelStyle={CommonStyles.h4}
            onPress={() => onPress(1)}
          />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,.5)',
    ...CommonProperties.centerAlignment,
  },
  innerContainer: {
    maxWidth: '90%',
    backgroundColor: 'white',
    ...CommonProperties.p5,
    ...CommonProperties.borderRadius1,
  },
  title: {
    ...CommonProperties.px4,
    ...CommonProperties.h3,
    textAlign: 'center',
  },
  firstButton: {
    ...CommonProperties.borderRadius4,
    ...CommonProperties.mb3,
  },
});

export default EventModal;
